import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent } from "util";

const states = [
  {
    name: "app.management.devolution-sellable-report",
    url: "/devolucao-por-produto",
    views: {
      "content@app": ConnectComponent(View, Presenter)
    },
    data: {
      navigation: {
        name: "Devolução por Produto",
        priority: 350,
        state: "app.management.devolution-sellable-report"
      }
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/management/devolution-sellable-report/index.js